import React from 'react';
import { PortfolioRadialGarden } from './PortfolioRadialGarden';
export function Portfolio() {
  return <PortfolioRadialGarden data-id="element-1123" />;
}